export default __webpack_public_path__ + "static/media/weather.71c209ec.png";